import axios, { AxiosError, AxiosHeaders, InternalAxiosRequestConfig } from "axios";

let accessToken: string | null = null;

// OPTIONAL: if your API returns refresh token in JSON (not cookie)
// you can keep it in memory or (less safe) localStorage for now:
let refreshToken: string | null = localStorage.getItem("refreshToken") || null;
let isRefreshing = false;
let pendingRequests: Array<() => void> = [];

export const setAccessToken = (token: string | null) => { accessToken = token; };
export const setRefreshToken = (token: string | null) => {
    refreshToken = token;
    if (token) localStorage.setItem("refreshToken", token);
    else localStorage.removeItem("refreshToken");
};
console.log("API baseURL:", process.env.REACT_APP_SERVICEURL);

export const api = axios.create({
    baseURL: process.env.REACT_APP_SERVICEURL ?? "http://localhost:5277",
    withCredentials: true,
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    //if (!config.headers) config.headers = new AxiosHeaders();
    //if (!(config.headers instanceof AxiosHeaders)) {
    //    config.headers = new AxiosHeaders(config.headers);
    //}
    if (accessToken) {
        (config.headers as AxiosHeaders).set("Authorization", `Bearer ${accessToken}`);
    }
    return config;
});

api.interceptors.response.use(
    (res) => res,
    async (error: AxiosError) => {
        const original = error.config as InternalAxiosRequestConfig & { _retry?: boolean };
        if (error.response?.status === 401 && !original?._retry) {
            if (isRefreshing) {
                await new Promise<void>((resolve) => pendingRequests.push(resolve));
                original._retry = true;
                if (!original.headers) original.headers = new AxiosHeaders();
                if (!(original.headers instanceof AxiosHeaders)) {
                    original.headers = new AxiosHeaders(original.headers);
                }
                if (accessToken) {
                    (original.headers as AxiosHeaders).set("Authorization", `Bearer ${accessToken}`);
                }
                return api(original);
            }

            original._retry = true;
            isRefreshing = true;

            try {
                // If your API uses httpOnly cookie for refresh:
                // const { data } = await api.post("/api/auth/refresh");
                // If your API expects refresh token in body (current implementation):
                const { data } = await api.post("/api/auth/refresh", { refreshToken });

                setAccessToken(data.accessToken);
                // If API rotates refresh tokens, update:
                if (data.refreshToken) setRefreshToken(data.refreshToken);

                pendingRequests.forEach((fn) => fn());
                pendingRequests = [];

                if (!original.headers) original.headers = new AxiosHeaders();
                if (!(original.headers instanceof AxiosHeaders)) {
                    original.headers = new AxiosHeaders(original.headers);
                }
                (original.headers as AxiosHeaders).set("Authorization", `Bearer ${accessToken}`);

                return api(original);
            } catch (e) {
                setAccessToken(null);
                setRefreshToken(null);
                pendingRequests.forEach((fn) => fn());
                pendingRequests = [];
                // Bubble up (your AuthContext can redirect to /login)
                return Promise.reject(e);
            } finally {
                isRefreshing = false;
            }
        }
        return Promise.reject(error);
    }
);